import { PropsWithChildren } from "react";

import { Label, Paragraph } from "@fronterahealth/frontera-ui-components";

interface ContentRowProps extends PropsWithChildren {
  title: string;
  isLast?: boolean;
  showTemplateDownloadLink?: boolean;
  subtitle?: string | React.ReactNode;
}
export const ContentRow: React.FC<ContentRowProps> = ({ title, subtitle, showTemplateDownloadLink, children }) => {
  return (
    <div className="flex w-full flex-col items-end">
      <div className="grid w-full grid-cols-8 items-start">
        <div className="col-span-3 flex flex-col">
          <Label colorType="primary" size="medium" displayType="loud">
            {title}
          </Label>
          {typeof subtitle === "string" ? (
            <Paragraph colorType="secondary" size="small" className="max-w-[80%]">
              {subtitle}
              {showTemplateDownloadLink ? (
                <>
                  {" "}
                  For best results, use our scoring templates found{" "}
                  <span
                    onClick={() => window.open("/downloads", "_blank")}
                    className="bg-transparent text-interaction-primary cursor-pointer"
                  >
                    here.
                  </span>
                </>
              ) : (
                <></>
              )}
            </Paragraph>
          ) : (
            subtitle
          )}
        </div>
        <div className="col-span-5 flex flex-col rounded-xl bg-bg-surface outline-solid outline-1 outline-border-medium p-6">
          {children}
        </div>
      </div>
    </div>
  );
};
